export const LOG_CREATE = "LOG_CREATE";
export const LOG_GET = "LOG_GET";
export const LOG_UNLOAD = 'LOG_UNLOAD';
export const LOG_DELETE = 'LOG_DELETE';
export const LOG_DELETE_LOCAL = 'LOG_DELETE_LOCAL';
export const LOG_GET_LAST_LOG = 'LOG_GET_LAST_LOG';
export const LOG_LOAD_LOGS = 'LOG_LOAD_LOGS';
export const LOG_LOAD_LOGS_NEWER = 'LOG_LOAD_LOGS_NEWER';
export const LOG_LOAD_LOGS_OLDER = 'LOG_LOAD_LOGS_OLDER';